import { action, observable } from 'mobx';
import type { CXRootStore } from '../../stores/cx-root.store';

export class FlowContextVariablesStore {
    rootStore: CXRootStore;

    @observable variables: Record<string, string> = {};

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    @action
    setVariable(key: string, value: string) {
        this.variables[key] = value;
    }

    getVariable(key: string) {
        return this.variables[key];
    }
}
